import { ContainerModule } from 'inversify';

import { IBaseDataList, Injects, ISkinDesc, ITranslationVersions, queryStringParams } from '@game-studio/arcade-base';
import { coreDataList } from '@/src/skins/core/data-list';
import { SkinName } from '@/src/main';

export async function getInternationalSkin(skinName: string): Promise<ISkinDesc> {
    const { skinDataList } = await import(`@/src/skins/${skinName}`);
    const { italySkinConfig } = await import(`@/src/skins/${skinName}/configs/italy-config`);

    if (skinDataList === undefined) {
        console.error(`skinDataList export missing in @/src/skins/${skinName}.`);
    }

    if (italySkinConfig === undefined) {
        console.error(`skinConfig export missing in @/src/skins/${skinName}/configs/italy-config.ts.`);
    }

    return { dataList: skinDataList, config: italySkinConfig } as ISkinDesc;
}

const italyCDNVersions = {
    core: 'ver-1.0.0',
    bankbonus: 'ver-1.0.0'
};

export const containerModule = new ContainerModule((bind, __, ___, rebind) => {
    rebind<ITranslationVersions>(Injects.TranslationVersions).toConstantValue({
        errors: 0,
        game: 0,
        shared: 0,
        chatRules: 0
    });

    rebind<IBaseDataList>(Injects.CoreDataList).toConstantValue(Object.assign({}, coreDataList, { version: italyCDNVersions.core }));

    rebind<() => void>(Injects.SkinFactory).toFactory(() => {
        const skinName = queryStringParams.currentSkin as SkinName;

        rebind(Injects.UserPrefsGameName).toConstantValue(skinName);
        return async () => {
            const skinDesc = await getInternationalSkin(skinName);
            bind<ISkinDesc>(Injects.Skin).toConstantValue({
                ...skinDesc,
                dataList: {
                    ...skinDesc.dataList,
                    version: italyCDNVersions[skinName]
                }
            });
        }
    });
});
